
import { SetupContext } from "vue";
import { BaseButton, BaseText } from "components/atoms";

export default {
  components: { BaseButton, BaseText },
  setup(props: {}, { emit }: SetupContext) {
    const handleOnRedirect = () => {
      emit("on-redirect");
    };
    return { handleOnRedirect };
  },
  emits: ["on-redirect"],
};
